<div class="wrapper">
	<div class="app-text__h2 header">{{header}}</div>
	<div class="content">
		<ng-content>
		</ng-content>
	</div>
</div>